import React from 'react'
import { Input, Form } from 'antd'
import Popup from '../../../components/Popup'

export default function TagPopup({
  visible = false,
  title = '',
  cancelHandler,
  saveHandler,
  data = {},
  loading = false
}) {
  const [form] = Form.useForm()

  function saveTag() {
    form
      .validateFields()
      .then((values) => {
        form.resetFields()
        saveHandler(values)
      })
      .catch((info) => {
        console.log('Validate Failed:', info)
      })
  }

  return (
    <Popup
      title={title}
      visible={visible}
      cancelHandler={() => (form.resetFields(), cancelHandler())}
      saveHandler={saveTag}
      loading={loading}
    >
      <Form requiredMark={false} form={form} layout='vertical' name='tag'>
        <Form.Item
          name='name'
          label='Name'
          initialValue={data.tag_name}
          rules={[
            {
              required: true,
              message: 'Please enter the name of tag!',
            },
          ]}
        >
          <Input placeholder='Ex. MONSOON' />
        </Form.Item>
        <Form.Item
          initialValue={data.description}
          name='description'
          label='Description'
        >
          <Input.TextArea showCount maxLength={255} placeholder='Ex. Monsoon speical offers for monsoon related products.' />
        </Form.Item>
      </Form>
    </Popup>
  )
}
